/**
 * @fileoverview The ONE reader of Global Privacy Control (LIFE-SHORTLISTED-001, the shopper privacy surface).
 * @package @puffin-core/marketing-shell
 *
 * A browser that sends Global Privacy Control reports it as `navigator.globalPrivacyControl === true`. The
 * consent provider treats it as a decline for a visitor who has made no choice, and the Google tag loads with
 * every consent default denied. Both read it HERE, so the two cannot disagree about one visitor.
 *
 * Only the literal `true` is the signal: an absent property, `false`, or any other value is no signal.
 *
 * A zero-import leaf: the Google loader reads it before any React tree exists.
 *
 * @module @puffin-core/marketing-shell/consent/privacySignal
 */

/**
 * @param {?{globalPrivacyControl?: *}} [nav] - the navigator to read (the page's own by default; a runtime
 *   with none answers false)
 * @returns {boolean} whether the visitor's browser sends Global Privacy Control
 */
export function readGlobalPrivacyControl(nav = globalThis.navigator) {
  return Boolean(nav) && nav.globalPrivacyControl === true;
}

export default readGlobalPrivacyControl;
